import { useEffect, useRef, useState } from "react";
import { useFormContext } from "react-hook-form";

const Otp = ({ otpLength = 6, name = 'otp', required = true, validate }) => {
    const [inputArr, setInputArr] = useState(new Array(otpLength).fill(''));
    const refArr = useRef([]);
    const { register, setValue, watch } = useFormContext();

    // Register the field with react-hook-form
    register(name, {
        required: required ? 'Required' : false,
        validate: validate,
    });

    const otpValue = watch(name);

    useEffect(() => {
        refArr.current[0]?.focus();
    }, []);

    // Update form value when inputArr changes
    useEffect(() => {
        const combinedOtp = inputArr.join('');
        setValue(name, combinedOtp, { shouldValidate: true });
    }, [inputArr, name, setValue]);

    const handleOnChange = (value, index) => {
        if (!/^\d?$/.test(value)) return;
        const newInputArr = [...inputArr];
        newInputArr[index] = value;
        setInputArr(newInputArr);
        if (value.length > 0 && index < otpLength - 1) {
            refArr.current[index + 1]?.focus();
        }
    };

    const handleOnKeyDown = (e, index) => {
        if (!e.target.value && e.key === 'Backspace') {
            refArr.current[index - 1]?.focus();
        }
    };

    const handleOnPaste = (e) => {
        e.preventDefault();
        const pastedData = e.clipboardData.getData("text").trim();
        if (!/^[0-9]+$/.test(pastedData)) return;

        const pastedOtp = pastedData.slice(0, otpLength).split("");
        const newInputArr = [...inputArr];

        pastedOtp.forEach((digit, index) => {
            newInputArr[index] = digit;
        });
        setInputArr(newInputArr);

        refArr.current[pastedOtp.length < otpLength ? pastedOtp.length : otpLength - 1]?.focus();
    };

    return (
        <div>
            <div className="text-sm font-medium text-gray-700">OTP {required && <span className='text-scogoorange'>*</span>}</div>
            <div onPaste={handleOnPaste}>
                {inputArr.map((input, index) => (
                    <input
                        key={index}
                        className="w-12 h-12 m-1 border border-gray-300 rounded-md text-center"
                        inputMode="numeric"
                        onChange={(e) => handleOnChange(e.target.value, index)}
                        value={inputArr[index]}
                        ref={(input) => (refArr.current[index] = input)}
                        onKeyDown={(e) => handleOnKeyDown(e, index)}
                        maxLength="1"
                    // Don't use name here as we're manually registering the combined value
                    />
                ))}
            </div>
            {/* Hidden input to store the actual value for form submission */}
            <input type="hidden" name={name} value={otpValue || ''} />
        </div>
    );
};

export default Otp;
